/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\WorldMapTooltip.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the geoFirewall module.
----------------------------------------------------------------*/


import { Globe } from 'lucide-react';

interface Props {
    name: string;
    x: number;
    y: number;
    visible: boolean;
}

export function WorldMapTooltip({ name, x, y, visible }: Props) {
    if (!visible || !name) return null;
    return (
        <div
            className="fixed pointer-events-none z-[99999] px-4 py-2.5 rounded-lg shadow-2xl animate-in fade-in-0 zoom-in-95 duration-150"
            style={{
                top: y - 50,
                left: x,
                transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, rgba(30,41,59,0.95) 0%, rgba(15,23,42,0.95) 100%)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255,255,255,0.1)',
                boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.05)',
            }}
        >
            <div className="flex items-center gap-2">
                <Globe className="h-3.5 w-3.5 text-emerald-400" />
                <span className="text-sm font-medium text-white">{name}</span>
            </div>
        </div>
    );
}
